/* istanbul ignore file */
import { mainApi } from "config";
import { getClientFor } from "infrastructure/http";
import { ITenant } from "ui/shared/models/common";

export interface IAccountRolesGetResponse {
  securityRoleId: string;
  tenantId: string;
  enterpriseId: string;
}

export interface IUserProfileGetResponse {
  tenants: ITenant[];
  securityRoles: IAccountRolesGetResponse[];
}

export const getUserProfile = async () => {
  return (await getClientFor(mainApi.name).get<IUserProfileGetResponse>("/profile")).data;
};
